import styled from "@emotion/styled"
import { Flex, Skeleton } from "src/components"

export const InventoryAndIntakeSkeleton = () => (
	<Flex $gap="xl">
		<HalfWidth>
			<Skeleton.List entries={4} withHeader />
		</HalfWidth>
		<HalfWidth>
			<Skeleton.List entries={4} withHeader />
		</HalfWidth>
	</Flex>
)

const HalfWidth = styled.div`
	width: 50%;
`
